module.exports = __webpack_public_path__ + "static/media/exhibitionText.322fc7b0.svg";